/**
 * Measures precise pixel width of text using canvas 2D context.
 *
 * Why canvas instead of CSS text-overflow: ellipsis?
 * - LabeledAvatar component is immutable - we must pre-truncate with "..." before passing text
 * - Need exact 30%/70% width allocation between name and description (requires pixel-perfect measurement)
 * - CSS ellipsis would require modifying LabeledAvatar's internal DOM structure
 * - Canvas provides accurate font metrics (kerning, proportional spacing) without DOM manipulation
 */
export const measureTextWidth = (text: string, fontSize: string = '12px', fontWeight: string = 'normal'): number => {
	if (typeof document === 'undefined') return text.length * 8;

	const canvas = document.createElement('canvas');
	const context = canvas.getContext('2d');
	if (!context) return text.length * 8;

	context.font = `${fontWeight} ${fontSize} -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif`;
	return context.measureText(text).width;
};
